module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-it-IT.cf9cdbcc.jpg";